export enum SearchRegionType {
  CITY = 'city',
  COUNTRY = 'country',
  STATE = 'state',
}